import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';

export interface Collar extends BaseEntity {
  name: string;
  imagePath: string | null;
  thumbnailPath?: string | null;
  imageWidth?: number | null;
  imageHeight?: number | null;
  sortOrder?: number;
}

export interface CreateCollarData {
  vestment: number;
  name: string;
  image?: File;
}

export type UpdateCollarData = Partial<CreateCollarData>;

const collarApi = createCrudApi<Collar, CreateCollarData, UpdateCollarData>(
  'collar'
);

export const deleteCollar = collarApi.delete;
export const reorderCollars = (vestmentId: number, ids: number[]) =>
  collarApi.reorder(ids, { vestment: vestmentId });

function buildCollarFormData(data: UpdateCollarData) {
  const formData = new FormData();
  if (data.vestment !== undefined) {
    formData.append('vestment', String(data.vestment));
  }
  if (data.name !== undefined) {
    formData.append('name', data.name);
  }
  if (data.image) {
    formData.append('image', data.image);
  }
  return formData;
}

export async function createCollar(data: CreateCollarData): Promise<Collar> {
  const formData = buildCollarFormData(data);
  const response = await axiosInstance.post('/collar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export async function updateCollar(
  id: number,
  data: UpdateCollarData
): Promise<Collar> {
  const formData = buildCollarFormData(data);
  const response = await axiosInstance.post(`/collar/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}
